import React, { useEffect, useState } from "react";
import { useRef } from "react";

const ImageWithFallback = ({ src, alt, className, functionError = () => null }) => {
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(false)

    const imgRef = useRef(null)

    useEffect(() => {
        setLoading(true)
        setError(false)
    }, [src])

    useEffect(() => {
        const img = imgRef.current
        if (!img) return

        if (img.complete && img.naturalWidth > 0) {
            setLoading(false)
        }
    }, [src])

    const handleImageLoad = () => {
        setLoading(false)
    }

    const handleImageError = () => {
        setLoading(false)
        setError(true)
    }

    return (
        <div>
            {(loading || error) && functionError()}
            {!error && (
                <img
                    ref={imgRef}
                    src={src}
                    alt={alt}
                    className={className}
                    onLoad={handleImageLoad}
                    onError={handleImageError}
                    style={{ display: loading ? "none" : "block" }}
                />
            )}
        </div>
    )
}

export default ImageWithFallback